import { Component, input, Input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { SiaCssEditorComponent, SiaJsEditorComponent } from '@sia/code-editor';
import {
  SiaCheckBoxComponent,
  SiaNumberboxComponent,
  SiaSelectBoxComponent,
  SiaTextBoxComponent,
} from '@sia/inputs';
import { SiaAccordionComponent, SiaTranslatePipe } from '@sia/shared';
import { SiaGridConfig } from '../../interfaces/sia-grid-config';

@Component({
  selector: 'sia-mat-grid-configurator-general',
  templateUrl: './sia-mat-grid-configurator-general.component.html',
  styleUrls: ['./sia-mat-grid-configurator-general.component.scss'],
  standalone: true,
  imports: [
    SiaNumberboxComponent,
    SiaCheckBoxComponent,
    SiaTextBoxComponent,
    SiaAccordionComponent,
    MatIcon,
    SiaJsEditorComponent,
    SiaCssEditorComponent,
    SiaSelectBoxComponent,
    SiaTranslatePipe,
    MatButton,
  ],
})
export class SiaMatGridConfiguratorGeneralComponent {
  @Input() gridConfiguration: SiaGridConfig = { group: {} };
  databaseFields = input<any[]>([]);
  gridConfigurationChange = output<SiaGridConfig>();
  gridConfSelectionTypes: string[] = ['single', 'multiple'];
  showTemplateSelectionTypes: { id: string; description: string }[] = [
    { id: 'mobile', description: 'Mobile' },
    { id: 'desktop', description: 'Desktop' },
    { id: 'both', description: 'Entrambi' },
    { id: 'tablet', description: 'Tablet' },
  ];
  gridConfAddingTypes: any[] = [
    { id: undefined, description: 'Nessuno' },
    { id: 'choice', description: 'Scelta' },
    { id: 'row', description: 'Riga' },
    { id: 'script', description: 'Script' },
  ];

  gridConfAddingTypesWhenTemplate: any[] = [
    { id: undefined, description: 'Nessuno' },
    { id: 'choice', description: 'Scelta' },
    { id: 'script', description: 'Script' },
  ];

  addStyle() {
    this.gridConfiguration.rowStyleConditions =
      this.gridConfiguration.rowStyleConditions ?? [];
    this.gridConfiguration.rowStyleConditions.unshift({});
  }
  removeStyle(filterIndex: number) {
    this.gridConfiguration.rowStyleConditions?.splice(filterIndex, 1);
  }
  addChoice() {
    this.gridConfiguration.addingChoisesItems =
      this.gridConfiguration.addingChoisesItems ?? [];
    this.gridConfiguration.addingChoisesItems.push({});
  }
  removeChoice(filterIndex: number) {
    this.gridConfiguration.addingChoisesItems?.splice(filterIndex, 1);
  }

  addPrefilter() {
    this.gridConfiguration.sqlPrefilters =
      this.gridConfiguration.sqlPrefilters ?? [];
    this.gridConfiguration.sqlPrefilters.unshift({});
  }
  removePrefilter(index: number) {
    this.gridConfiguration.sqlPrefilters?.splice(index, 1);
  }

  addSpParams() {
    this.gridConfiguration.params = this.gridConfiguration.params ?? [];
    this.gridConfiguration.params.unshift({});
  }

  removeSpParams(index: number) {
    this.gridConfiguration.params?.splice(index, 1);
  }
  addSubGroup() {
    this.gridConfiguration.subGroups = this.gridConfiguration.subGroups ?? [];
    this.gridConfiguration.subGroups.unshift({});
  }

  removeSubGroup(index: number) {
    this.gridConfiguration.subGroups?.splice(index, 1);
  }

  addGroupAction() {
    this.gridConfiguration.group = this.gridConfiguration.group ?? {};
    this.gridConfiguration.group.groupActions =
      this.gridConfiguration.group.groupActions ?? [];
    this.gridConfiguration.group.groupActions.unshift({});
  }

  removeGroupAction(index: number) {
    this.gridConfiguration.group?.groupActions?.splice(index, 1);
  }

  ngOnInit() {
    this.gridConfiguration.group = this.gridConfiguration.group ?? {
      groupDataField: '',
      groupNameDataField: '',
      groupText: '',
    };
  }
}
